import { render, staticRenderFns } from "./CrudQA.vue?vue&type=template&id=4171d815&scoped=true"
import script from "./CrudQA.vue?vue&type=script&lang=js"
export * from "./CrudQA.vue?vue&type=script&lang=js"
import style0 from "./CrudQA.vue?vue&type=style&index=0&id=4171d815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171d815",
  null
  
)

export default component.exports